<script setup lang="ts">
import { Monitor, Cloud, Brain, Shield, ChevronRight } from 'lucide-vue-next';
import { useI18n } from 'vue-i18n'
import type { Service } from '../../types/interfaces';

const { t, tm } = useI18n()

const serviceIcons = [Monitor, Cloud, Brain, Shield]
const services = tm('serviceSection.services') as Service[]
</script>

<template>
  <section id="services" class="py-32 bg-gradient-to-b from-gray-50 to-white">
    <div class="container mx-auto px-4">
      <div class="text-center mb-12">
        <h2 class="text-center text-3xl font-bold mb-12 uppercase">
          {{ t('serviceSection.heading') }}
        <div class="h-1 bg-red-500 w-20 mx-auto mt-2"></div>
      </h2>
      </div>
      <div class="grid md:grid-cols-4 gap-8">
        <div 
          v-for="(service, index) in services" 
          :key="index" 
          class="bg-white rounded-lg p-8 shadow-lg hover:shadow-xl transition-shadow duration-300"
        >
          <component :is="serviceIcons[index]" class="w-8 h-8 text-indigo-600" />
          <h3 class="text-xl font-semibold mt-4 mb-2">{{ service.title }}</h3>
          <p class="text-gray-600 mb-4">{{ service.description }}</p>
          <ul class="space-y-2">
            <li 
              v-for="(feature, idx) in service.features" 
              :key="idx" 
              class="flex items-center text-gray-600"
            >
              <ChevronRight class="w-4 h-4 text-indigo-600 mr-2" />
              {{ feature }}
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>
</template>